import Big from 'big.js';

export function formatAmount(value) {
  try {
    return new Big(value).div(100).toNumber();
  } catch (error) {
    return 0;
  }
}
